import React, { useEffect, useState, useCallback } from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useNavigate,
} from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import Login from "./pages/Login";
import ShopDetailsPage from "./pages/ShopDetails";
import PaymentsPage from "./pages/Payments";
import SubscriptionPage from "./pages/Subscription";
import { Sidebar } from "./components/Sidebar";
import { api, getToken, clearToken } from "./lib/api";

function Shell({ children, shop }) {
    return (
        <div className="flex min-h-screen">
            <Sidebar
                shopName={shop?.basic?.name}
                adminName={shop?.admin?.name}
            />
            <main className="flex-1 px-4 md:px-10 py-8 md:py-10 max-w-[1200px] mx-auto w-full">
                {children}
            </main>
        </div>
    );
}

function ProtectedRoute({ children }) {
    const [shop, setShop] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const refresh = useCallback(async () => {
        try {
            const data = await api.me();
            setShop(data);
        } catch (err) {
            clearToken();
            navigate("/login", { replace: true });
        } finally {
            setLoading(false);
        }
    }, [navigate]);

    useEffect(() => {
        if (!getToken()) {
            navigate("/login", { replace: true });
            return;
        }
        refresh();
    }, [navigate, refresh]);

    if (loading) {
        return (
            <div
                className="min-h-screen flex items-center justify-center"
                data-testid="app-loading"
            >
                <div className="text-slate-400">Loading...</div>
            </div>
        );
    }

    return <Shell shop={shop}>{React.cloneElement(children, { shop, refresh })}</Shell>;
}

function App() {
        return (
            <BrowserRouter>
            <Toaster
                position="top-right"
                theme="dark"
                richColors
                toastOptions={{
                    style: {
                        background: "#111a2e",
                        border: "1px solid #243049",
                        color: "#e2e8f0",
                    },
                }}
            />
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                    path="/shop"
                    element={
                        <ProtectedRoute>
                            <ShopDetailsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/shop/payments"
                    element={
                        <ProtectedRoute>
                            <PaymentsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/shop/subscription"
                    element={
                        <ProtectedRoute>
                            <SubscriptionPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
